"use client";

const routeDataHcp = [
  {
    path: '/cah-overview',
    headerNavLabel: <>CAH Overview</>,
  }, {
    path: '/mechanism-of-action',
    headerNavLabel: <>MOA</>,
  }, {
    path: '/clinical-information#trial-1-efficacy-link',
    headerNavLabel: <>Clinical Information</>,
  }, {
    path: '/dosing',
    headerNavLabel: <>Dosing</>,
  }, {
    path: '/videos',
    headerNavLabel: <>Videos</>,
  }, {
    path: '/support-resources',
    headerNavLabel: <>Support & Resources</>,
  }, {
    path: '/peerconnect',
    headerNavLabel: <>PeerConnect</>,
  },
];

const headerNavegationHcpItems = routeDataHcp.filter(({headerNavLabel}) => headerNavLabel !== undefined).map(({
  headerNavLabel,
  path,
  leaveSiteLink,
  externalLink,
  targetBlank,
}) => ({
  headerNavLabel,
  path,
  leaveSiteLink,
  externalLink,
  targetBlank,
}));

export {headerNavegationHcpItems};